import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import styled from 'styled-components';
import { Category } from 'api/timesheets/categories';
import { Option, Select } from 'components/atoms/select';
import { CellEditorParams } from '../types';

const StyledSelect = styled(Select)`
  padding: 0 !important;
  margin-bottom: var(--spacing-03);

  & .ozone-select__control {
    outline-offset: -2px !important;
  }
`;
const Wrapper = styled.div`
  width: 296px;
  margin-top: var(--spacing-05);
  min-height: 350px;
  width: 272px;
  display: flex;
  flex-direction: column;
`;

const selectStyles = {
  control: (provided) => ({
    ...provided,
    margin: '0 var(--spacing-05)',
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: '14px',
    boxShadow: 'none',
    margin: 'var(--spacing-03) 0 var(--spacing-03)',
  }),
  menuItem: (provided) => ({
    ...provided,
    padding: '0 var(--spacing-03)',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    display: 'flex !important',
  }),
};

interface OptionEditorProp extends CellEditorParams {
  categoryOptions: Option<Category>[];
}
export const CategoryEditor = forwardRef<unknown, OptionEditorProp>(
  ({ value: propValues, categoryOptions, api, node, data, onChange }, ref) => {
    const [value, setValue] = useState(propValues);

    useImperativeHandle(ref, () => {
      return {
        getValue: () => {
          return value;
        },
        isPopup: () => true,
        getPopupPosition: () => 'under',
      };
    });

    useEffect(() => {
      if (!value) {
        return;
      }
      if (value === propValues) {
        return;
      }
      onChange?.({ api, node, newValue: value, data });
    }, [api, data, node, onChange, propValues, value]);

    return (
      <Wrapper>
        <StyledSelect
          options={categoryOptions}
          value={value?.id}
          type="tag"
          onChange={setValue}
          styles={selectStyles}
          menuIsOpen
        />
      </Wrapper>
    );
  },
);
